/* Six-month storefront wording. Does not alter products, orders or checkout policies. */
(() => {
  'use strict';
  if (window.mzWarrantyWordingReady) return;
  window.mzWarrantyWordingReady = true;
  const excluded = 'script,style,noscript,textarea,select,option,[contenteditable="true"],.cr-google-reviews,.jdgm-rev,.spr-review,blockquote';
  const blocks = 'p,li,h1,h2,h3,h4,h5,h6,summary,dt,dd,td,th,figcaption,label,span,strong,a';
  function editsFor(text) {
    const edits = [];
    const add = (start, end, value) => {
      if (!edits.some(e => start < e.end && end > e.start)) edits.push({ start, end, value });
    };
    const duration = /\b(?:30|thirty)[\s\u00a0\u2010-\u2015-]*days?\b/gi;
    const before = /\b(?:30|thirty)[\s\u00a0\u2010-\u2015-]*days?\b(?=[\s\u00a0]+(?:(?:limited|parts|repair|device|service)[\s\u00a0]+){0,3}warrant(?:y|ies)\b)/gi;
    let match;
    while ((match = before.exec(text))) {
      add(match.index, match.index + match[0].length, /DAY/.test(match[0]) ? '6-MONTH' : '6-month');
    }
    const after = /\bwarrant(?:y|ies|ed)\b[^.!?\n;]{0,90}?\b(?:30|thirty)[\s\u00a0\u2010-\u2015-]*days?\b/gi;
    while ((match = after.exec(text))) {
      if (/return|refund|exchange|shipping|delivery|cancel/i.test(match[0])) continue;
      duration.lastIndex = 0;
      const term = duration.exec(match[0]);
      if (term) add(match.index + term.index, match.index + term.index + term[0].length, /DAY/.test(term[0]) ? '6 MONTHS' : '6 months');
    }
    // Correct the contradictory one-year sentence in the existing Mobile Zone warranty paragraph only.
    const old = 'This warranty covers operational defects that arise within the first year after purchase or repair.';
    const at = text.indexOf(old);
    if (at !== -1) {
      const start = at + old.indexOf('first year');
      add(start, start + 'first year'.length, 'first 6 months');
    }
    return edits.sort((a, b) => b.start - a.start);
  }
  function updateElement(element) {
    if (!element || element.closest(excluded)) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) { return node.parentElement && !node.parentElement.closest(excluded) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    const nodes = [];
    let node, text = '';
    while ((node = walker.nextNode())) {
      nodes.push({ node, start: text.length, end: text.length + node.data.length });
      text += node.data;
    }
    for (const edit of editsFor(text)) {
      let written = false;
      for (const item of nodes) {
        if (item.end <= edit.start || item.start >= edit.end) continue;
        const from = Math.max(0, edit.start - item.start);
        const to = Math.min(item.end, edit.end) - item.start;
        item.node.replaceData(from, to - from, written ? '' : edit.value);
        written = true;
      }
    }
  }
  function scan(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    if (root.matches(blocks)) updateElement(root);
    root.querySelectorAll(blocks).forEach(updateElement);
    // Also cover simple unwrapped text labels in service cards.
    if (!root.children.length) updateElement(root);
  }
  function init() {
    scan(document.body);
    const pending = new Set();
    let frame = null;
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') {
          const parent = record.target.parentElement;
          if (parent && !parent.closest(excluded)) pending.add(parent.closest(blocks) || parent);
        } else for (const node of record.addedNodes) {
          const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
          if (element && !element.closest(excluded)) pending.add(element.closest(blocks) || element);
        }
      }
      if (pending.size && frame === null) frame = requestAnimationFrame(() => {
        frame = null;
        const roots = Array.from(pending); pending.clear();
        roots.forEach(scan);
      });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
    document.addEventListener('shopify:section:load', event => scan(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
